'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useDateTimes } from '@personly/libs-providers';
interface Props {
  days: number;
  interval: number;
  placeholder: string;
}
const CookieExpires = t0 => {
  const $ = _c(5);
  const {
    days,
    interval,
    placeholder
  } = t0;
  const dateTimes = useDateTimes();
  let t1;
  if ($[0] !== dateTimes || $[1] !== days || $[2] !== interval || $[3] !== placeholder) {
    t1 = days === 0 ? placeholder : dateTimes.timeSince(interval);
    $[0] = dateTimes;
    $[1] = days;
    $[2] = interval;
    $[3] = placeholder;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const toExpires = t1;
  return toExpires;
};
export default CookieExpires;